<template>
	<div class="datetime-container is-warning">
		<VueCtkDateTimePicker :min-date="todayDate" :disabled="clearValue == true" :noClearButton="clearValue" color="#248dcd" button-color="#248dcd" :onlyDate="true" :right="true" :buttonNowTranslation="t('today')" formatted="ll" :label="usedLabel" v-model="value" format="YYYY-MM-DD"></VueCtkDateTimePicker>
		<input type="hidden" :name="InputName" :value="value" >
	</div>
</template>
<script>
	import trans from "../SiteComponents/translation/general.json";
	export default {
		name: 'DatePicker',
		props:{
			OldValue:{
				required:false
			},
			InputName:{
				required:true,
				type:String
			},
			sitelocale:{
				required:true,
				type:String
			},
			label:{
				type:String,
				default: null
			}
		},
		data() {
			return {
				value:"",
                clearValue:false,
				usedLabel:null,
				
			};
		},
		mounted(){
			this.$translate.setLang(this.sitelocale);
			if(this.OldValue){
				this.value = this.OldValue;
                this.clearValue = true;
			}
			if(this.label === null){
				this.usedLabel = this.$translate.text('select_time')
			}else{
				this.usedLabel = this.label
			}
		},
		computed: {
			todayDate: function () {
				let d = new Date(),
				month = '' + (d.getMonth() + 1),
				day = '' + d.getDate(),
				year = d.getFullYear();

				if (month.length < 2) 
					month = '0' + month;
				if (day.length < 2) 
					day = '0' + day;

				return [year, month, day].join('-');
			}
		},
		locales: trans,
	}
</script>
<style type="text/css">
</style>
